import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class Nospartenaires extends React.Component {
  render() {
  	    return (
    	<I18n ns="translations">
        {
          (t, { i18n }) => (
					  <section id="prop-slider-section" className="text-center">
						  <div className="container-fluid">
							<h1>{t('partnerstitle')}<span className="resp-block">{t('partnerstitle2')}</span></h1>
							<p>{t('partnerspara1')}</p>
							<p>{t('partnerspara2')}</p>

							<div id="myCarousel" className="carousel slide prop-carousel hidden-xs" data-ride="carousel">
					          
					           <ol className="carousel-indicators">
					            <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
					            <li data-target="#myCarousel" data-slide-to="1"></li>
					          </ol>

					           <div className="carousel-inner">
					            <div className="item active">
					          		<div className="container">          
					            		<div className="row">
											<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire01.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire02.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire03.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire04.png"/>
						                	</div>
						               	</div>
					               	</div>
					            </div>

					            <div className="item">
					           		<div className="container">   
						             	<div className="row">
											<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire05.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire06.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire07.png"/>
						                	</div>
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire08.png"/>
						                	</div>
						               	</div>
						            </div>
					            </div>
					          </div>

					          <a id="carousel-left" className="left carousel-control" href="#myCarousel" data-slide="prev">
					            <span className="slider-arrow"><img src="images/slider_left_arrow.png"/></span>
					            <span className="sr-only">Previous</span>
					          </a>
					          <a id="carousel-right" className="right carousel-control" href="#myCarousel" data-slide="next">
					            <span className="slider-arrow"><img src="images/slider_right_arrow.png"/></span>
					            <span className="sr-only">Next</span>
					          </a>
					        </div>

					        <div id="myCarousel1" className="carousel slide prop-carousel visible-xs" data-ride="carousel">
					       
					          <ol className="carousel-indicators">
					            <li data-target="#myCarousel1" data-slide-to="0" className="active"></li>
					            <li data-target="#myCarousel1" data-slide-to="1"></li>
					            <li data-target="#myCarousel1" data-slide-to="2"></li>
					            <li data-target="#myCarousel1" data-slide-to="3"></li>
					            <li data-target="#myCarousel1" data-slide-to="4"></li>
					            <li data-target="#myCarousel1" data-slide-to="5"></li>
					            <li data-target="#myCarousel1" data-slide-to="6"></li>
					            <li data-target="#myCarousel1" data-slide-to="7"></li>

					          </ol>

					           <div className="carousel-inner">
					            <div className="item active">
					          		<div className="container">          
					            		<div className="row">
											<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire01.png"/>
						                	</div>
						                </div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire02.png"/>
						                	</div>
						                </div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire03.png"/>
						                	</div>
						                </div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire04.png"/>
						                	</div>
						               	</div>
					               	</div>
					            </div>
					            <div className="item">
					           		<div className="container">   
						             	<div className="row">
											<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire05.png"/>
						                	</div>
						                </div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire06.png"/>
						                	</div>
						               	</div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire07.png"/>
						                	</div>
						                </div>
						            </div>
						        </div>
						        <div className="item ">
					          		<div className="container">          
					            		<div className="row">
						                	<div className="col-md-3 col-xs-12 text-center">               
						                  		<img src="images/partenaire08.png"/>
						                	</div>
						               	</div>
						            </div>
					            </div>
					          </div>

					          <a id="carousel-left1" className="left carousel-control" href="#myCarousel1" data-slide="prev">
					            <span className="slider-arrow"><img src="images/slider_left_arrow.png"/></span>
					            <span className="sr-only">Previous</span>
					          </a>
					          <a id="carousel-right1" className="right carousel-control" href="#myCarousel1" data-slide="next">
					            <span className="slider-arrow"><img src="images/slider_right_arrow.png"/></span>
					            <span className="sr-only">Next</span>
					          </a>
					        </div>
						</div>

						
					</section>
	              )
                }
          </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Propos/Nospartenaires/Nospartenaires.js